import api from './api/api';
import apiHandlers from './api';
import logoutMonitor from './monitors/logoutMonitor';

api.addMonitor(logoutMonitor);

export default apiHandlers;
